export default __webpack_public_path__ + "2c73b5052306cad4c43a1008bc5799ff.svg";